/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var header = document.querySelector("header");
var header_height = header.offsetHeight;

var add_class_on_scroll = () => header.classList.remove("Header--transparent");
var remove_class_on_scroll = () => header.classList.add("Header--transparent");

function handleScroll() {
  var scrollpos = window.scrollY;

  if (scrollpos >= header_height) {
    add_class_on_scroll();
  } else {
    remove_class_on_scroll();
  }
}

// Check scroll position on page load
window.addEventListener("load", function() {
  handleScroll();
});

// Add scroll event listener
window.addEventListener("scroll", handleScroll);
if(document.body.classList.contains('template-index')){
  var imageHeight = document.querySelector('.signup_image-wrapper--cover .stretch_image-background');
const elemHgt = imageHeight.offsetHeight;
document.querySelector('.signup__text-container').style.height = elemHgt + "px";
window.addEventListener('resize', function(event){
  var imageHeight = document.querySelector('.signup_image-wrapper--cover .stretch_image-background');
const elemHgt = imageHeight.offsetHeight;
document.querySelector('.signup__text-container').style.height = elemHgt + "px";
});
}
document.querySelectorAll(".block-swatch__radio").forEach(function(radio) {
    radio.addEventListener("change", function() {
        var val = this.value;
        
        // Hide all elements with the class 'product_details'
        document.querySelectorAll('.product_details').forEach(function(detail) {
            detail.style.display = 'none';
        });

        // Show the element that has the data attribute matching the selected radio value
        document.querySelectorAll(`[data="${val}"]`).forEach(function(matchingElement) {
            matchingElement.style.display = 'block';
        });
    });
});
